const headRowsCompany = {
  name: 'Empresa',
  email: 'E-mail',
  accountable: 'Responsable',
};

export default headRowsCompany;
